module.exports = __webpack_public_path__ + "assets/fonts/arrow-up.51cc3baa.svg";